module.exports = __webpack_public_path__ + "officialStatic/img/solution-value-eight4.700836f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/solution-value-eight4.png
// module id = wyc3
// module chunks = 0